var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-button",
        {
          staticClass: "help-desk-button",
          attrs: { size: "is-small", "icon-right": "file" },
          on: {
            click: function ($event) {
              _vm.isComponentModalActive = true
            },
          },
        },
        [_vm._v("\n    HelpDesk\n  ")]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { "has-modal-card": "", "trap-focus": "" },
          model: {
            value: _vm.isComponentModalActive,
            callback: function ($$v) {
              _vm.isComponentModalActive = $$v
            },
            expression: "isComponentModalActive",
          },
        },
        [
          _c("div", { staticClass: "help-desk-modal" }, [
            _c("div", { staticClass: "help-desk-header" }),
            _vm._v(" "),
            _c("div", { staticClass: "ongoing-tasks" }, [
              _c("div", { staticClass: "new-issue" }, [
                _c(
                  "div",
                  { staticClass: "new-issue-container" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "new-issue-button",
                        attrs: { "icon-right": "plus" },
                        on: {
                          click: function ($event) {
                            _vm.newIssueModal = true
                          },
                        },
                      },
                      [_vm._v("\n              New Issue\n            ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "closed-issues" },
                      [
                        _c(
                          "b-checkbox",
                          {
                            model: {
                              value: _vm.closedIssues,
                              callback: function ($$v) {
                                _vm.closedIssues = $$v
                              },
                              expression: "closedIssues",
                            },
                          },
                          [_vm._v("Show Closed Issues")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "current-open-issues" }, [
                  _c("div", { staticClass: "open-issues-all-users" }, [
                    _vm._v(
                      "\n              Current Open Issues(All Users)\n            "
                    ),
                  ]),
                  _vm._v("\n            Open issues 2\n          "),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "open-issues" }, [
                _c("div", { staticClass: "open-issues-container" }, [
                  _c("div", { staticClass: "open-issues-label" }, [
                    _vm._v("\n              Open issues\n            "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "open-issues-currently-worked-on" },
                    [_vm._v("\n              currently worked\n            ")]
                  ),
                ]),
                _vm._v(" "),
                _vm.closedIssues
                  ? _c("div", { staticClass: "closed-issues-container" }, [
                      _c("div", { staticClass: "closed-issues-label" }, [
                        _vm._v("\n              Closed issues\n            "),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "closed-previous-issues" }, [
                        _vm._v("\n              Closed Issues\n            "),
                      ]),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "help-desk-footer" }, [
              _c("div", { staticClass: "modal-footer-text" }, [
                _vm._v("\n          Build Aviator - Help desk Menu\n        "),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "footer-close-button" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "close-button",
                      attrs: { type: "is-danger" },
                      on: {
                        click: function ($event) {
                          _vm.isComponentModalActive = false
                        },
                      },
                    },
                    [_vm._v("Close")]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          model: {
            value: _vm.newIssueModal,
            callback: function ($$v) {
              _vm.newIssueModal = $$v
            },
            expression: "newIssueModal",
          },
        },
        [
          _c("div", { staticClass: "new-issue-modal" }, [
            _c("div", { staticClass: "logo-container" }, [
              _c("img", {
                staticClass: "modal-logo",
                attrs: { src: "img/logo-new.png", alt: "logo" },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-form" }, [
              _c(
                "div",
                { staticClass: "team-viewer" },
                [
                  _c(
                    "b-field",
                    {
                      staticClass: "team-viewer-id",
                      attrs: { label: "Team Viewer Id" },
                    },
                    [
                      _c("b-input", {
                        model: {
                          value: _vm.teamViewerId,
                          callback: function ($$v) {
                            _vm.teamViewerId = $$v
                          },
                          expression: "teamViewerId",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-field",
                    {
                      staticClass: "team-viewer-password",
                      attrs: { label: "Team Viewer password" },
                    },
                    [
                      _c("b-input", {
                        model: {
                          value: _vm.teamViewerPassword,
                          callback: function ($$v) {
                            _vm.teamViewerPassword = $$v
                          },
                          expression: "teamViewerPassword",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "modal-ref" },
                [
                  _c(
                    "b-field",
                    { attrs: { label: "Project Reference" } },
                    [
                      _c("b-input", {
                        staticClass: "modal-ref-input",
                        model: {
                          value: _vm.projectRef,
                          callback: function ($$v) {
                            _vm.projectRef = $$v
                          },
                          expression: "projectRef",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-field",
                    { attrs: { label: "Select issue type" } },
                    [
                      _c(
                        "b-dropdown",
                        {
                          attrs: { "aria-role": "list" },
                          scopedSlots: _vm._u([
                            {
                              key: "trigger",
                              fn: function () {
                                return [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "issue-type-dropdown",
                                      attrs: {
                                        "icon-right": "angle-down",
                                        expanded: "",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.issueType) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                        },
                        [
                          _vm._v(" "),
                          _vm._l(_vm.issueTypes, function (type) {
                            return _c(
                              "b-dropdown-item",
                              {
                                key: type,
                                attrs: { "aria-role": "listitem" },
                                on: {
                                  click: function ($event) {
                                    return _vm.setIssueType(type)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(type) +
                                    "\n              "
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-field",
                    { attrs: { label: "Issue Description" } },
                    [
                      _c("b-input", {
                        attrs: { maxlength: "200", type: "textarea" },
                        model: {
                          value: _vm.issueDescription,
                          callback: function ($$v) {
                            _vm.issueDescription = $$v
                          },
                          expression: "issueDescription",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-add-file" }, [
              _c(
                "div",
                { staticClass: "add-file-box" },
                [
                  _c(
                    "b-field",
                    [
                      _c(
                        "b-upload",
                        {
                          attrs: { multiple: "", expanded: "" },
                          model: {
                            value: _vm.dropFiles,
                            callback: function ($$v) {
                              _vm.dropFiles = $$v
                            },
                            expression: "dropFiles",
                          },
                        },
                        [
                          _c("section", { staticClass: "add-file-button" }, [
                            _c(
                              "p",
                              [
                                _c("b-icon", {
                                  attrs: { icon: "plus", size: "is-large" },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "files-uploaded-box" },
                    _vm._l(_vm.dropFiles, function (file, index) {
                      return _c(
                        "span",
                        { key: index, staticClass: "add-file-tag" },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(file.name) +
                              "\n                "
                          ),
                          _c("button", {
                            staticClass: "delete is-small",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteDropFile(index)
                              },
                            },
                          }),
                        ]
                      )
                    }),
                    0
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "support-request-buttons" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "modal-button",
                      on: {
                        click: function ($event) {
                          return _vm.submitData()
                        },
                      },
                    },
                    [_vm._v("Ok")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "modal-cancel-button modal-button",
                      on: {
                        click: function ($event) {
                          return _vm.closeModal()
                        },
                      },
                    },
                    [_vm._v("Cancel")]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }